import { cn } from "@/lib/utils";
import { View } from "@/components/ui";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { Typography } from "@/components/shared/typography";
import type { DurationOption } from "@/components/shared/service-radio-item/types";

export function SectionDurationRadio({
  item,
  selected,
  onSelect,
  subTitle,
}: {
  item: DurationOption;
  selected: boolean;
  onSelect(): void;
  subTitle: string;
}) {
  return (
    <View
      className={cn(
        "flex cursor-pointer flex-row items-center justify-between gap-3 rounded-xl border px-4 py-3 transition",
        selected
          ? "border-primary-border bg-primary-surface"
          : "border-secondary-border bg-white",
      )}
      onClick={onSelect}
    >
      <Typography variant="label-sm">{item.duration} Hours</Typography>
      <View className="flex flex-row items-center gap-3">
        <Typography variant="label-sm" color="brand-primary">
          {subTitle}
        </Typography>
        <RadioGroupItem value={String(item.value)} checkCircle />
      </View>
    </View>
  );
}
